import React, { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import initializeAppEnv from './app/init';
import Footer from './Footer'
import PrivateRoute from './PrivateRoute';
import AdminRoute from './AdminRoute';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const Formulaire = lazy(() => import('./pages/Form'))



// Initializing different libraries
initializeAppEnv()

function App() {


  return (
    <>
    <Router>
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/form" element={<PrivateRoute><Formulaire /></PrivateRoute>} />
              {/* Place new routes over this */}
              <Route path="/app/*" element={<AdminRoute><Layout /></AdminRoute>} />

              <Route path="*" element={<PrivateRoute />} />
            </Routes>
          </div>
          {/* Footer visible sur toutes les pages */}
          <Footer />
        </div>
      </Router>
    </>
  )
}

export default App
